import React from "react";

import "./partner-styles.css";
import "./scss/index.scss";
import * as Sentry from "@sentry/react";
import { Amplify, ResourcesConfig } from "aws-amplify";
import hu from "date-fns/locale/hu";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import localizedFormat from "dayjs/plugin/localizedFormat";
import updateLocale from "dayjs/plugin/updateLocale";
import "./services/translation/i18n";
import i18n from "i18next";
import { registerLocale } from "react-datepicker";
import ReactDOM from "react-dom/client";
registerLocale("hu", hu);

import App from "./App";
import cognitoConfig from "./cognito-config.json";
import reportWebVitals from "./reportWebVitals";

import "dayjs/locale/en";
import "dayjs/locale/es";
import "dayjs/locale/hu";

dayjs.extend(updateLocale);
dayjs.extend(localizedFormat);
dayjs.extend(isoWeek);

document.documentElement.lang = i18n.language;

i18n.on("languageChanged", (lng) => {
  document.documentElement.setAttribute("lang", lng);
});

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://10319b3b8fd0b7dcb8ede152367c5da0@o4506988282249216.ingest.us.sentry.io/4506988283691008",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

Amplify.configure({
  Auth: {
    Cognito: cognitoConfig,
  } as ResourcesConfig["Auth"],
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
